export enum applicantTypes {
  FETCH_APPLICANT_REQUEST = "FETCH_APPLICANT_REQUEST",
  FETCH_APPLICANT_SUCCESS = "FETCH_APPLICANT_SUCCESS",
  FETCH_APPLICANT_FAILURE = "FETCH_APPLICANT_FAILURE",
}